import FormModalStyled from './FormModalStyled';

let modalInstance = null;

const { confirm } = FormModalStyled;

function showConfirm (props) {
   modalInstance = confirm({
    ...props,
    onCancel: (...args) => {
      modalInstance = null;
      props.onCancel?.(...args);
    },
    onOk: (...args) => {
      modalInstance = null;
      props.onOk?.(...args);
    },
  });
}

const confirmModal = (props) => showConfirm(props);

confirmModal.destroy = () => {
  if (modalInstance) {
    modalInstance.destroy();
    modalInstance = null;
  }
};

confirmModal.isOpen = () => modalInstance !== null;

export default confirmModal;
